import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AUTHORIZATION_MODULE_NAMESPACE, AUTHORIZATION_SIGNOUT } from '../../store/authorization';


const AuthorizationStore = namespace(AUTHORIZATION_MODULE_NAMESPACE)

@Component
class ErrorContainer extends Vue {

  // @AuthorizationStore.Action(AUTHORIZATION_SIGNOUT)
  // handleSignout: (self: any) => void;

  mounted() {
    console.log('error page')
  }
  handleLogout() {
    // this.handleSignout(this)
  }
}

export default ErrorContainer;


// WEBPACK FOOTER //
// ./src/containers/error/index.ts